import React, { useEffect, useState } from "react";
import "./AdvCheckout.css";
import NavbarComponent from "../../components/navbar/NavbarComponent";
import Footer from "../../components/footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { API } from "../../constants/Api";

function AdvCheckout() {
  const location = useLocation();
  // const { selectedZipCodes } = location.state || [];
  // const { featured } = location.state || [];
  // const { selected } = location.state || [];
  // Get data from localStorage
const advertiserCheckoutData = JSON.parse(localStorage.getItem('advertiserCheckoutData')) || {};

// Destructure with default empty arrays if data doesn't exist
const { selectedZipCodes = [], featured = [], selected = [] } = advertiserCheckoutData;

// Optional: Clear the data from localStorage after retrieving it
// localStorage.removeItem('advertiserCheckoutData');
  // const { selectedZipCodes = [], featured = null, selected = [] } = location.state || {};
  const advertiserID = localStorage.getItem("advertiserId");
  const [total, setTotal] = useState("");
  const [loading, setLoading] = useState(false)
const navigate = useNavigate()



 

  useEffect(()=>{
    // if (!location.state) {
 
    //   navigate(-1);
    //   return;
    // }

    const fetchPrice = async () => {
      
    // const fArray = [];

    // fArray.push(featured);
    
    const data = {
      advertiser: advertiserID, // Use "advertiser" instead of "advertiserID"
      featured: {
        zipcodes: featured,
        featured: true,
      },
      normal: selected.map((zip) => ({
        zipcode: zip.trim(),
        topBanner: "http://example.com/top-banner.jpg",
        bottomBanner: "http://example.com/bottom-banner.jpg",
      })),
    };

    try {
      const response = await fetch(
        `${API}/advertiser-stripe/calculate-total-price`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );
      const result = await response.json();

      if (response.ok) {
        setTotal(result.totalPrice)
      } 
    } catch (error) {
      console.error("Error during fetch:", error.message);
      alert("Error: " + error.message);
    }
    }

    fetchPrice()

  },[advertiserID])

function check () {
  if(total.length < 1){
    return false;
  }
  return true;
}
  const handlePayNow = async (e) => {
    e.preventDefault();

    // const fArray = [];

    // fArray.push(featured);

    const isValid = await check()

    if(isValid){
      setLoading(true)
      const data = {
        advertiser: advertiserID, // Use "advertiser" instead of "advertiserID"
        featured: {
          zipcodes: featured,
          featured: true,
        },
        normal: selected.map((zip) => ({
          zipcode: zip.trim(),
          topBanner: "http://example.com/top-banner.jpg",
          bottomBanner: "http://example.com/bottom-banner.jpg",
        })),
      };
  data.totalPrice = total;
      try {
        const response = await fetch(
          `${API}/advertiser-stripe/create-advertiser-banner`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          }
        );
        const result = await response.json();
  
        if (result.url) {
          console.log("Redirecting to Stripe Checkout:", result.url);
          window.location.href = result.url;
        } else if (result.banner) {
          console.log("Banner created successfully:", result.banner);
          alert("Banner created successfully!");
        } else {
          console.error("Error in response:", result);
          alert("Error: " + JSON.stringify(result));
        }
      } catch (error) {
        console.error("Error during fetch:", error.message);
        alert("Error: " + error.message);
      }finally{
        setLoading(false)
      }
    }
   
  };
  return (
    <>
      <div className="advertiser-details">
        <NavbarComponent />
        <div
          className="container-fluid px-0"
          style={{ paddingBottom: "120px" }}
        >
          <div className="row px-0 mx-0 advertiser-details-page-section-1">
            <div className="col-md-6 px-0 d-flex align-items-center">
              <div className="container-fluid px-0">
                <div className="row px-0 mx-0">
                  <div className="container-fluid">
                    <h2 className="agent-register-heading">Checkout</h2>
                    {/* <p className="before-begin-span">Got any worries? No sweat, we’re here for you!</p> */}
                  </div>
                </div>
                <div className="row px-0 mx-0">
                  <div className="container-fluid checkout-page-card-3">
                    <div className="row">
                      <table className="table ads-table">
                        <thead className="ads-table-head">
                          <tr className="ads-table-row-head">
                            <th className="ads-table-data-head-1">Zip Codes</th>
                            <th className="ads-table-data-head">Featured</th>
                            <th className="ads-table-data-head-last">
                              Listing
                            </th>
                          </tr>
                        </thead>
                        <tbody className="ads-table-body">
                          {selectedZipCodes &&
                            selectedZipCodes.map((zip) => (
                              <tr key={zip} className="ads-table-body-row">
                                <td className="ads-table-data">
                                  <div className="tour-date w-100 ps-3 text-start">
                                    {zip}
                                  </div>
                                </td>
                                <td className="ads-table-data-1">
                                  <div className="table-layout-content-header-box d-flex justify-content-center">
                                  {featured.includes(zip) ? (
                                      <img
                                        role="button"
                                        src="/img/checked.svg"
                                        className="img-fluid me-3"
                                        alt=""
                                        // onClick={() => handleRemoveItem(zip)}
                                      />
                                    ) : (
                                      <img
                                        role="button"
                                        src="/img/uncheck.svg"
                                        className="img-fluid opacity-50 me-3"
                                        alt=""
                                        // onClick={() => handleCheckClick(zip)}
                                      />
                                    )}
                                  </div>
                                </td>
                                <td className="ads-table-data-last">
                                  <div className="tour-date w-100 pe-3 text-end">
                                    {" "}
                                    {selected.includes(zip) ? (
                                      <img
                                        role="button"
                                        src="/img/checked.svg"
                                        className="img-fluid me-3"
                                        alt=""
                                        // onClick={() => handleRemoveItem(zip)}
                                      />
                                    ) : (
                                      <img
                                        role="button"
                                        src="/img/uncheck.svg"
                                        className="img-fluid opacity-50 me-3"
                                        alt=""
                                        // onClick={() => handleCheckClick(zip)}
                                      />
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="row">
                      <div className="col-12 devider-lead"></div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <h2 className="checkout-grand-total">Total</h2>
                      </div>
                      <div className="col-md-6 text-end">
                        <h2 className="checkout-grand-total-price">${total}/month</h2>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 devider-lead"></div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        {
                          loading?
                          <button
                      
                          className="btn agent-register-button"
                        >
                          Processing...
                        </button>
                        :
                        <button
                        onClick={handlePayNow}
                        className="btn agent-register-button"
                      >
                        Pay Now
                      </button>
                        }
                    
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 px-0 d-none d-lg-block justify-centent-end align-items-center">
              <div className="container-fluid d-flex justify-content-end">
                <img
                  src="/img/checkout.svg"
                  className="img-fluid checkout-image"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AdvCheckout;
